<div class="row shadow p-4 mb-5 bg-white rounded mt-3 monitor-dashboard-chart-card">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <h5 class="mb-2 monitor-dashboard-card-title">
        <span class="monitor-dashboard-chart-title-link" @click="onTitleClick">{{$t('monitorDashboard.sendersExpirationTimeline')}}</span>
      </h5>
    </div>

    <div class="monitor-dashboard-chart-stage monitor-dashboard-chart-stage-senders-timeline">
      <div
        ref="chartViewport"
        :style="chartViewportStyle"
        role="region"
        :aria-label="$t('monitorDashboard.sendersExpirationTimeline')"
      >
        <div :style="{ width: chartCanvasWidthPx, height: '100%', position: 'relative' }">
          <canvas v-show="!isLoading && hasData" id="sender-expiration-timeline-chart-canvas" class="monitor-dashboard-chart-canvas" role="img"
            :aria-label="$t('monitorDashboard.sendersExpirationTimeline')"></canvas>

          <div v-if="isLoading" class="monitor-dashboard-skeleton-wrap monitor-dashboard-state-layer" role="status" aria-live="polite">
            <span class="sr-only">{{$t('monitorDashboard.loading')}}</span>
            <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-block" aria-hidden="true"></div>
          </div>

          <div v-else-if="!hasData" class="monitor-dashboard-state-block monitor-dashboard-state-layer">
            <p class="mb-0 font-weight-bold">{{ $t('monitorDashboard.noSenderssDataFor', { chartName: $t('monitorDashboard.sendersExpirationTimeline') }) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
